import React from 'react';

const CountryFlags = ({ language }) => {
    const getFlag = (lang) => {
        switch (lang) {
            case 'en':
                return '🇬🇧';
            case 'de':
                return '🇩🇪';
            case 'es':
                return '🇪🇸';
            case 'fr':
                return '🇫🇷';
            case 'it':
                return '🇮🇹';
            case 'pt':
                return '🇵🇹';
            default:
                return '🇬🇧';
        }
    };

    return (
        <span className="flag-icon" aria-hidden="true">
            {getFlag(language)}
        </span>
    );
};

export default CountryFlags;
